module.exports = __webpack_public_path__ + "static/img/gbz-805-365bb.fd7ad7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gbz-805-365bb.jpg
// module id = dRLp
// module chunks = 0